import { render, staticRenderFns } from "./ProjectContextModalProduct.vue?vue&type=template&id=8bc88f76&"
import script from "./ProjectContextModalProduct.vue?vue&type=script&lang=js&"
export * from "./ProjectContextModalProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports